<div class="bgCard">

    <div class="dilogStl">
        <h1 class="viewHeading" mat-dialog-title>VIEW BRANCH OFF PEAK TIMINGS</h1>
        <button align="end" mat-icon-button mat-dialog-close>
            <mat-icon style="color:#0038FF" svgIcon="feather:x"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">

        <div class="card dataCard mt-4" style="height: auto!important;">
            <div class="mt-2 ml-3 ">
                <h4 class="headings">
                    Branch Off Peak Timings
                </h4>
                <div class="col-12 d-flex flex-column align-items-center" style="max-height:400px; overflow-y:scroll;">
                    <table class="table " style="width: 90%;">
                        <thead class="thead-dark"
                            style="background: #000;color: #fff; position: sticky; top: 0; z-index: 1;">
                            <tr>
                                <th scope="col">Day</th>
                                <th scope="col">Timing Type</th>
                                <th scope="col">Start Time</th>
                                <th scope="col">End Time</th>
                                <th scope="col">Pro Rata Percentage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of branchPeakTimings">
                                <td>{{item.day_of_week}}</td>
                                <td *ngIf="item.timing_type == 'PEAK_TIMING'" class="">Peak Time</td>
                                <td *ngIf="item.timing_type == 'OFF_PEAK_TIMING'" class="">Off Peak Time</td>
                                <td>{{item.start_time}}</td>
                                <td>{{item.end_time}}</td>
                                <td>{{item.pro_rata_percentage}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </mat-dialog-content>
</div>